var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [
        {
          name: "chat-scroll",
          rawName: "v-chat-scroll",
          value: _vm.directiveOptions,
          expression: "directiveOptions",
        },
      ],
      ref: "container",
      staticClass: "scrollable",
      class: _vm.classes,
      on: {
        scroll: _vm.handleScrollThrottled,
        "v-chat-scroll-top-reached": function ($event) {
          return _vm.$emit("v-chat-scroll-top-reached")
        },
      },
    },
    [
      _vm.withShadows
        ? _c("div", {
            staticClass: "scroll-shadow top",
            class: { show: _vm.state.top },
          })
        : _vm._e(),
      _vm._t("default"),
      _vm.withShadows
        ? _c("div", {
            staticClass: "scroll-shadow bottom",
            class: { show: _vm.state.bottom },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }